import { render, staticRenderFns } from "./LgButtonAcoesIcons.vue?vue&type=template&id=0b569b24"
import script from "./LgButtonAcoesIcons.vue?vue&type=script&lang=js"
export * from "./LgButtonAcoesIcons.vue?vue&type=script&lang=js"
import style0 from "./LgButtonAcoesIcons.vue?vue&type=style&index=0&id=0b569b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports